import { render } from "./WpeCode.vue?vue&type=template&id=843debc2"
import script from "./WpeCode.vue?vue&type=script&lang=js"
export * from "./WpeCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/options-controls/WpeCode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "843debc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('843debc2', __exports__)) {
    api.reload('843debc2', __exports__)
  }
  
  module.hot.accept("./WpeCode.vue?vue&type=template&id=843debc2", () => {
    api.rerender('843debc2', render)
  })

}


export default __exports__